<template>
    <div :class="isMobile?'dynamicBoxB':'dynamicBox'">
        <div :class="isMobile?'dynamicShowB':'dynamicShow'">
            <div :class="isMobile?'dongtBox':'leftBox'">
                <div class="dyTitle">会员动态</div>
                <img class="dyImg" src="@/assets/home/dtImg.png" alt="">
                <div class="clearfix mt20" v-for="(item,index) in dynaList" :key="index">
                    <span class="fl point"></span>
                    <span class="fl titlebox overh" @click="lookInfo(item.NewsGuid,106104)">{{ item.Title }}</span>
                </div>
                <div class="mt20 textc czhu">
                    <span class="curp" @click="lookMore(106104)">查看更多&gt;</span>
                </div>
            </div>
            <div :class="isMobile?'dongtBox':'rightBox'">
                <div class="dyTitle">风采展示</div>
                <img class="dyImg" src="@/assets/home/fcImg.png" alt="">
                <div class="clearfix mt20" v-for="(item,index) in fengcList" :key="index">
                    <span class="fl point"></span>
                    <span class="fl titlebox overh" @click="lookInfo(item.NewsGuid,106105)">{{ item.Title }}</span>
                </div>
                <div class="mt20 textc czhu">
                    <span class="curp" @click="lookMore(106105)">查看更多&gt;</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default{
        data(){
            return{
                form:{
                    cataCode:106104,
                    pageIndex:1,
                    pageSize:5
                },
                forms:{
                    cataCode:106105,
                    pageIndex:1,
                    pageSize:5
                },
                dynaList:[],
                fengcList:[]
            }
        },
        methods:{
           
             //获取会员动态
             getListData(){
                this.Request({
                    url: '/api/NewsData/GetNewsDataTwo',
                    method: 'get',
                    data:{
                        ...this.form
                    }
                }).then((data) => {
                   this.dynaList = data.Data
                })
            },

            getListDatas(){
                this.Request({
                    url: '/api/NewsData/GetNewsDataTwo',
                    method: 'get',
                    data:{
                        ...this.forms
                    }
                }).then((data) => {
                   this.fengcList = data.Data
                })
            },

            //查看详情
            lookInfo(id,type){
                this.$router.push({
                    path:'/service/info?id='+id+'&type='+type
                })
            },
            //查看更多
            lookMore(type){
                this.$router.push({
                    path:'/service?type='+type
                })
            },
        },

        mounted(){
            this.getListData()
            this.getListDatas()
        }
    }
</script>

<style scoped>
    .dynamicBox{
        width: 100%;
        height: 720px;
        background: url('../../../assets/home/dtBg.png') no-repeat;
        background-size: cover;
        padding-top: 68px;
    }
    .dynamicBoxB{
        width: 100%;
        background: url('../../../assets/home/dtBg.png') no-repeat;
        background-size: cover;
        padding: 10px;
        padding-top: 50px;
    }
    .dynamicShow{
        width: 1400px;
        margin: 0 auto;
        display: flex;
        justify-content: space-around;
    }
    .leftBox,.rightBox{
        width: 500px;
        height: 600px;
        background-color: #fff;
        border-radius: 5px;
        border: 1px solid #C0C0C0;
        padding: 20px;
        padding-top: 50px;
        position: relative;
    }
    .dongtBox{
        width: 100%;
        background-color: #fff;
        border-radius: 5px;
        border: 1px solid #C0C0C0;
        position: relative;
        padding: 20px;
        padding-top: 50px;
        margin-bottom: 40px;
    }
    .dyImg{
        width: 100%;
    }
    .point{
        width: 5px;
        height: 5px;
        background-color: #0D69F0;
        border-radius: 50%;
        margin-top: 10px;
        margin-right: 5px;
    }
    .titlebox{
        width: calc(100% - 20px);
        cursor: pointer;
        font-size: 18px;
    }
    .titlebox:hover{
        color: #0D69F0;
    }
    .dyTitle{
        position: absolute;
        top: -20px;
        left: 50%;
        margin-left: -75px;
        width: 150px;
        height: 40px;
        background: url('../../../assets/home/tbg.png') no-repeat;
        background-size: 100% 100%;
        text-align: center;
        line-height: 40px;
        font-size: 18px;
    }
</style>